import { render, staticRenderFns } from "./AllLocationsView.vue?vue&type=template&id=b6037bf8&scoped=true&"
import script from "./AllLocationsView.vue?vue&type=script&lang=js&"
export * from "./AllLocationsView.vue?vue&type=script&lang=js&"
import style0 from "./AllLocationsView.vue?vue&type=style&index=0&id=b6037bf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6037bf8",
  null
  
)

export default component.exports